export const LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const LOGIN_FAIL = "USER_LOGIN_FAIL";
export const LOGOUT = "USER_LOGOUT";
export const GOOGLE_LOGIN_REQUEST = "GOOGLE_LOGIN_REQUEST";
export const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS";
export const GOOGLE_LOGIN_FAIL = "GOOGLE_LOGIN_FAIL";
export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";
export const DELETE_ERROR = "DELETE_ERROR";
export const LOGIN_WITH_TOKEN_REQUEST="LOGIN_WITH_TOKEN_REQUEST";
export const LOGIN_WITH_TOKEN_SUCCESS="LOGIN_WITH_TOKEN_SUCCESS";
export const LOGIN_WITH_TOKEN_FAIL="LOGIN_WITH_TOKEN_FAIL";